// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2W49u","image":"Header_image__1mB95","name":"Header_name__15qBA","info":"Header_info__2Z4a1","infoRow":"Header_infoRow__1jF_O"};